<template>
        <div class="warp">
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>选择客户经理：</div>
                        <div class="content">
                            <el-select v-model="sendInfoTwo.id" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in customerManagerLists"
                                        :key="item.id"
                                        :label="item.realName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.id']">错误提示：{{errors['sendInfoTwo.id']}}</div>
                    <div class="child">
                        <div class="name"></div>
                        <div class="content">
                            <div class="hint significance">重要提示：重新指派客户经理后，该用户与原客户经理相关的数据都会移交给新的客户经理，请谨慎操作</div>
                        </div>
                    </div>
                    <div class="child">
                        <div class="name"></div>
                        <div class="content">
                            <div class="doubleBtn">
                              <el-button type="primary" size="small" @click="submit(1)">确认</el-button>
                              <el-button  @click="cancel" size="small">取消</el-button>
                          </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import upLoad from '../../components/upLoad'
import {getDict} from "@/axios";
export default {
    components:{
        // breadcrumb,
        upLoad
    },
    data(){
        return{
            statusList: [],//服务类型
			id:'',
      usId: void 0,
           customerManagerLists: [],//客户经理
                sendInfoTwo: {
                    id: null,//客户经理id
                    ids: [],//移交人id
                },
                multipleSelection:[]
			
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
            'sendInfoTwo.id': {
                test: function (val) {
                    if (this.multipleSelection.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                    if (val) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '选择用户或客户经理'
            }
        },
	created() {
    this.getDic();
    const {multipleSelection} = this.$route.query
    this.multipleSelection = multipleSelection || []
    this.$vuerify.clear();
	},
   
    methods:{
       //确定按钮
            submit: function (type) {
                this.$vuerify.clear();
                if (type == 1) { //移交客户
                    let ary = ['sendInfoTwo.id'];
                    let formData = new FormData();
                    for (let item of this.multipleSelection) {
                        formData.append("ids", item);
                    }
                    if (this.$vuerify.check(ary)) {
                        this.$axiosz.put('backstage/sysUser/manage/customerManager/' + this.sendInfoTwo.id, formData).then((r) => {
                            if (r.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '移交客户成功!'
                                });
                                this.getData();
                                this.cancel();
                                this.dialogMove = false
                            } else {
                                this.$alert(r.msg)
                            }
                        })
                    }
                } else { //添加账号
                    let arys = ['userName'];
                    if (this.$vuerify.check(arys)) {
                        // this.$axiosz.get('backstage/sysUser/manage/userName/'+this.userName).then((r)=>{
                        //     if(r.code==200){
                        //         this.$axiosz.post('backstage/sysUser/manage/'+this.userName).then((r)=>{
                        //             if(r.code==200){
                        //                 this.$message({
                        //                 type: 'success',
                        //                 message: '添加账号成功!'
                        //             });
                        //             this.getData();
                        //             this.cancel();
                        //             }else{
                        //                 this.$alert(r.msg)
                        //             }
                        //         })
                        //     }else{
                        //         this.$alert(r.msg)
                        //     }
                        // })
                    }
                }
            },
        cancel() {
            this.$router.back(-1);
        },
        //获取字典
            async getDic() {
                // 分类
                const customerManagerLists = await this.$axiosz.get('backstage/sysUser/manage/customerManager')
                if(customerManagerLists.code === 200) this.customerManagerLists = customerManagerLists.data || [];
                
            }
    }
}
</script>

<style lang="scss" scoped>
.warp{
     height:96%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
        padding-top: 40px;
        .forms{
            max-width: 450px;
            margin: auto;
            .child{
                .content{
                    flex: 1;
					.el-textarea{
						width: 100% !important;
					}
                }
				/deep/ .el-select{
					width: 100% !important;
				}
				
				.name{
					width: 150px !important;
					text-align: right;
				}
            }
			.singleBtn{
				text-align: center;
			}
			.error{
				padding-left: 100px;
			}
        }
    }
}
</style>